import { defineModel, serializable, castings as castTo } from '../model'

/**
 * AllSigningUps is our representation of EventAllSigningUps
 */
class AllSigningUps {
    @serializable()
    totalItems: number

    /**
     * List of attendees
     *
     */
    @castTo.collection('SigningUp')
    @serializable()
    items: ApiModel<'SigningUp'>[]
}

export default defineModel(AllSigningUps)
